export const GetUserEngagementsQuery = `query getUser($user: UserIdentityInput) {
  user(userIdentity: $user) {
    engagements(queryArgs: {productType: ENGAGEMENT_PREFERENCES}) {
      elements {
        id
        actionType
        resource {
          id
          type
          ... on Person {
            name
          }
          ... on Topic {
            name
          }
          ... on Company {
            longName
          }
          ... on Securities {
            longName
          }
        }
      }
    }
  }
}`;

export const GetUserAuthorsQuery = `query getUserAuthors($user: UserIdentityInput) {
  user(userIdentity: $user) {
      engagements(queryArgs: {productType: AUTHOR_FOLLOW}) {
          elements {
              id
              actionType
              resource {
                  id
                  type
                  ... on Person {
                      name
                  }
              }
          }
      }
  }
}`;

export const GetUserTopicsQuery = `query getUserTopics($user: UserIdentityInput) {
  user(userIdentity: $user) {
      engagements(queryArgs: {productType: ENGAGEMENT_PREFERENCES, resourceType: Topic}) {
          elements {
              id
              actionType
              resource {
                  id
                  type
                  ... on Topic {
                      name
                  }
              }
          }
      }
  }
}`;

export const GetUserSecuritiesQuery = `query getUserSecurities($user: UserIdentityInput) {
  user(userIdentity: $user) {
      engagements(queryArgs: {productType: ENGAGEMENT_PREFERENCES}) {
          elements {
              id
              actionType
              resource {
                  id
                  type
                  ... on Securities {
                      longName
                  }
              }
          }
      }
  }
}`;

export const FollowMutation = `mutation follow(
  $user: UserIdentityInput!,
  $engagementsUpdate: BulkUpdateEngagementsInput!
) {
    bulkUpdateEngagements(
      userIdentity: $user,
      bulkUpdateEngagementsInput: $engagementsUpdate)
    {
      success
    }
}`;

export const DeleteFollowMutation = `mutation deleteFollow(
  $user: UserIdentityInput!,
  $deleteEngagement: DeleteEngagementInput!
) {
  deleteEngagement(userIdentity: $user, deleteInput: $deleteEngagement) {
    success
  }
}`;
